module.exports = __webpack_public_path__ + "static/NeuzeitGro-Reg-74896b221f4c2a20f6646a7418076af6.woff";